import React from 'react';
import { PhoneOff, Pause, Play, SkipForward, X } from 'lucide-react';

export default function RunBarControls({
  session,
  busyAction,
  hasConnectedLeg,
  onToggleSmartLocalId,
  onHangupConnected,
  onPause,
  onResume,
  onSkipSet,
  onEndSession,
}) {
  return (
    <div className="flex items-center gap-1.5 shrink-0">
      {/* Smart Local ID Live Toggle */}
      <button
        type="button"
        onClick={onToggleSmartLocalId}
        disabled={busyAction !== null}
        className={`px-2.5 py-1.5 rounded-lg text-xs border transition flex items-center gap-1.5 font-semibold ${
          session.smartLocalId !== false
            ? 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40 hover:bg-emerald-500/30'
            : 'bg-white/5 text-white/50 border-white/10 hover:bg-white/10'
        }`}
        title="Automatically matches your outbound Caller ID to the prospect's local area code"
        aria-label="Toggle Smart Local ID"
      >
        <span className="text-[10px]">Smart Local ID</span>
        <span className={`text-[9px] px-1.5 py-0.2 rounded font-bold ${
          session.smartLocalId !== false ? 'bg-emerald-400/30 text-emerald-200' : 'bg-white/10 text-white/40'
        }`}>
          {session.smartLocalId !== false ? 'ON' : 'OFF'}
        </span>
      </button>

      {hasConnectedLeg ? (
        <button
          onClick={onHangupConnected}
          disabled={busyAction !== null}
          className="px-3 py-1.5 rounded-lg text-xs bg-red-500/25 hover:bg-red-500/45 text-red-100 border border-red-500/40 shadow-sm transition flex items-center gap-1.5 font-semibold"
          title="Hang up — drop this leg (voicemail/no answer) and advance to the next set"
          aria-label="Hang up connected call"
        >
          <PhoneOff className="w-3.5 h-3.5" /> Hang Up
        </button>
      ) : null}

      {session.status === 'running' || session.status === 'queued' ? (
        <button
          onClick={onPause}
          disabled={busyAction !== null}
          className="px-3 py-1.5 rounded-lg text-xs bg-white/5 hover:bg-white/10 text-white/80 border border-white/10 transition flex items-center gap-1.5"
          title="Pause — finish in-flight calls, no new sets"
        >
          <Pause className="w-3.5 h-3.5" /> Pause
        </button>
      ) : session.status === 'paused' ? (
        <button
          onClick={onResume}
          disabled={busyAction !== null}
          className="px-3 py-1.5 rounded-lg text-xs bg-emerald-500/25 hover:bg-emerald-500/40 text-emerald-100 border border-emerald-500/40 transition flex items-center gap-1.5 font-semibold"
        >
          <Play className="w-3.5 h-3.5" /> Resume
        </button>
      ) : (
        // Ended / unknown state: keep the toggle mounted (disabled) so the bar
        // layout never shifts or loses its primary controls.
        <button
          disabled
          className="px-3 py-1.5 rounded-lg text-xs bg-white/5 text-white/30 border border-white/10 flex items-center gap-1.5 cursor-not-allowed"
        >
          <Pause className="w-3.5 h-3.5" /> Pause
        </button>
      )}

      <button
        onClick={onSkipSet}
        disabled={busyAction !== null}
        className="px-3 py-1.5 rounded-lg text-xs bg-white/5 hover:bg-white/10 text-white/80 border border-white/10 transition flex items-center gap-1.5"
        title="Skip current set"
      >
        <SkipForward className="w-3.5 h-3.5" /> Skip Set
      </button>

      <button
        onClick={onEndSession}
        disabled={busyAction !== null}
        className="px-3 py-1.5 rounded-lg text-xs bg-red-500/15 hover:bg-red-500/30 text-red-200 border border-red-500/20 transition flex items-center gap-1.5"
      >
        <X className="w-3.5 h-3.5" /> {session.status === 'completed' || session.status === 'cancelled' ? 'Dismiss' : 'End Session'}
      </button>
    </div>
  );
}
